import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { CreateTemplateVersionDocument } from './create.generated';

export const useCreateTemplateVersion = (
  options: ApiOptions<typeof CreateTemplateVersionDocument> = {},
) => {
  const { t } = useTranslation();

  return useMutation(CreateTemplateVersionDocument, {
    ...useNotifications(CreateTemplateVersionDocument, {
      failure: t('api.common.error_generic'),
      success: (data) =>
        data.createTemplateVersion?.template?.latestVersion != null
          ? t('api.template_versions.create_success', {
              version: data.createTemplateVersion.template.latestVersion.version,
            })
          : t('api.template_versions.create_success_no_version'),
    }),

    ...options,
  });
};
